/**************************************************
 * Nombre:       Imagen_TextoEstilo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import comillas from '../../../../Recursos/ic_comillas.svg'
import {theme} from "../../../../Tema";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

const Imagen_TextoEstilo = ({item}) => {
    const {sCell} = useResponsive()


    const htmlFrom = (htmlString) => {
        const cleanHtmlString = DOMPurify.sanitize(htmlString,
            {USE_PROFILES: {html: true}});
        const html = parse(cleanHtmlString);
        return html;
    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography
                    sx={{fontSize: sCell ? 24 : 40, fontWeight: 600, lineHeight: 1.2}}
                >{item.nombre}</Typography>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    background: `url(${item.img})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    height: sCell ? 200 : 400,
                    mt: 3
                }}
            >


            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 3}}>
                <Typography sx={{fontSize: 20}}>
                    {htmlFrom(item?.textoEstilo)}
                </Typography>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    border: 1,
                    borderStyle: 'dashed',
                    borderColor: theme.palette.secondary.main,
                    borderRadius: 1,
                    p: 3,
                    mt: 2
                }}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: sCell ? 24 : 32, fontWeight: 600, lineHeight: 1.2}}>
                        {item.frase}
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -9}}>
                    <img src={comillas} alt="comillas" width={50} height={'auto'}/>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Imagen_TextoEstilo